/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import styles from './styles.module.scss';
import { formatDate, formatPrice, getImageURL, showData } from 'utils/common';
import { useTranslation } from 'react-i18next';
import { Image, Skeleton, SpaceProps } from 'antd-mobile';

type Props = {
  buildingName?: string;
  branchName?: string;
  roomName?: string;
  availableDate?: string;
  address?: string;
  price?: number;
  isSkeleton?: boolean;
  branchImgUrl?: string;
};

function AvailableRoomCard({
  buildingName,
  branchName,
  roomName,
  availableDate,
  address,
  isSkeleton = false,
  price,
  branchImgUrl = '',
  ...nest
}: Props & SpaceProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.contractCard} {...nest}>
      <div className={styles.blockInfo}>
        {isSkeleton ? (
          <Skeleton
            animated
            style={{
              width: '200px',
              height: '22px',
            }}
          />
        ) : (
          <>
            {availableDate ? (
              <p className={styles.comingRoom}>
                {showData(availableDate && formatDate(availableDate))}
              </p>
            ) : (
              <p className={styles.emptyRoom}>{t('title.empty-room')}</p>
            )}
            <p className={styles.price}>{showData(price && formatPrice(price, true))}</p>
          </>
        )}
      </div>
      <div className={styles.topInfo}>
        <div className={styles.buildingLogo}>
          {isSkeleton ? (
            <Skeleton
              animated
              style={{
                width: '100%',
                height: '100%',
              }}
            />
          ) : (
            <Image src={branchImgUrl} />
          )}
        </div>
        <div className={styles.mainInfo}>
          {isSkeleton ? (
            <Skeleton
              animated
              style={{
                width: '100%',
                height: 'var(--font-lg)',
              }}
            />
          ) : (
            <p className="font-bold font-lg color-black">{showData(buildingName)}</p>
          )}
          {isSkeleton ? (
            <Skeleton
              animated
              style={{
                width: '100%',
                height: 'var(--font-md)',
              }}
            />
          ) : (
            <p className="font-bold font-md color-grey-01">
              {t('title.room')}: <span className="color-black">{showData(roomName)}</span>
            </p>
          )}
        </div>
      </div>
      <div className={styles.bodyInfo}>
        {isSkeleton ? (
          <Skeleton
            animated
            style={{
              width: '100%',
              height: '18px',
            }}
          />
        ) : (
          <p className="font-bold font-sm color-grey-01">
            {t('title.partner')}: <span className="color-black">{showData(branchName)}</span>
          </p>
        )}
        {isSkeleton ? (
          <Skeleton
            animated
            style={{
              width: '100%',
              height: '18px',
            }}
          />
        ) : (
          <p className="font-bold font-sm color-grey-01">
            {t('title.location')}: <span className="color-black">{showData(address)}</span>
          </p>
        )}
      </div>
    </div>
  );
}

export default React.memo(AvailableRoomCard);
